const routes = [
    {
        path: "/cartoon/animation/application/form",
        component: () => import("../pages/ApplicationForm")
    },
    {
        path: "/cartoon/animation/application/login",
        component: () => import("../pages/Login")
    },
    {
        path: "/cartoon/animation/application/register",
        component: () => import("../pages/Register")
    },
    {
        path: "/cartoon/animation/application/forgot/password",
        component: () => import("../pages/ForgotPassword")
    },
    /// Admin
    {
        path: "/cartoon/animation/applications",
        component: () => import("../pages/admin/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'cartoonanimationapplication_index'
        }
    },
    {
        path: "/cartoon/animation/application/exam-types",
        component: () => import("../pages/admin/examTypes/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: "cartoonanimationapplicationexamtype_index",
        }
    },
    {
        path: "/cartoon/animation/application/quotas",
        component: () => import("../pages/admin/quotas/Index"),
        meta: {
            isAuthenticated: true,
            permission: "cartoonanimationapplicationquota_index"
        }
    }

];

export default routes;
